// extracted by mini-css-extract-plugin
export default {"block":"Loader_block__yQBrM","fullscreen":"Loader_fullscreen__X9nOz","spin":"Loader_spin__7C1L1"};